import { FETCH_RESCHEDULE_DAYS, FETCH_RESCHEDULE_DAYS_SUCCESS } from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    entities: []
};

const fetchingRescheduleDays = (state, action) => {
    return {
        ...state,
        isFetching: true
    };
};

const fetchRescheduleDaysSuccess = (state, action) => {
    return {
        ...state,
        entities: [...action.atpRescheduleDays],
        isFetching: false
    };
};

const handlers = {
    [FETCH_RESCHEDULE_DAYS]: fetchingRescheduleDays,
    [FETCH_RESCHEDULE_DAYS_SUCCESS]: fetchRescheduleDaysSuccess
};

export const getATPRescheduleDays = (state) => state.atpRescheduleDays;

export default function atpRescheduleDays(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

//Actions
export function fetchRescheduleDays(athletePlanId, startDate, endDate, lang = 'en') {
    return {
        type: FETCH_RESCHEDULE_DAYS,
        payload: {
            athletePlanId,
            startDate,
            endDate,
            lang
        }
    };
}
